// utils/Sort/checkDate/L5PlanDate.js
const L5PlanDate = (initiative) => {
  if (!initiative?.timeline || !Array.isArray(initiative.timeline)) {
    return null;
  }

  const l5Entry = initiative.timeline.find((entry) => entry.stage === 'L5');
  if (!l5Entry?.date?.plan) {
    return null;
  }

  const planDate = new Date(l5Entry.date.plan);
  return isNaN(planDate.getTime()) ? null : planDate;
};

export default L5PlanDate;
